
import FlashHtmlFile from '~/components/Common/NewsFlashView/FlashHtmlFile'
// import FlashListContainer from '~/components/Common/NewsFlashView/FlashListContainer.vue'

export default {
    name: 'MarketNewsFlash',
    components: { 
        FlashHtmlFile
        // FlashListContainer,
    },
}
